import * as React from "react"
import { PreferenceCenter } from "@ua/web-sdk/lib/remote-data/preference-center"

import { EmailPreferenceCenterEntry } from "../../bootstrap"
import { SubscriptionFormClient } from "../../SubscriptionForm/client"
import { createChannelSubscriptions } from "../utils"
import {
  Loading,
  SavePreferences,
  Subscriptions,
  UpdateSubscriptions,
} from "./types"

export default function useChannelSubscriptionManager(
  preferenceCenter: PreferenceCenter,
  channelId: string,
  entry: EmailPreferenceCenterEntry
): [Loading, Subscriptions, UpdateSubscriptions, SavePreferences] {
  const [loading, setLoading] = React.useState(true)
  const subscriptionFormClient = React.useMemo(
    () => new SubscriptionFormClient(channelId, entry.auth.secret),
    [entry.auth, channelId]
  )
  const [subscriptions, setSubscriptions] = React.useState<Subscriptions>({})
  const updateSubscriptions: UpdateSubscriptions = React.useCallback(
    (mutation) => {
      setSubscriptions((subscriptions) => {
        return {
          email: { ...subscriptions.email, [mutation.id]: mutation.subscribed },
        }
      })
    },
    [setSubscriptions, subscriptions]
  )
  const savePreferences = React.useCallback(async () => {
    const lists = Object.entries(
      subscriptions.email ?? {}
    ).map(([id, subscribed]) => ({ id, subscribed }))
    await subscriptionFormClient.updateLists(lists)
  }, [subscriptions])

  React.useEffect(() => {
    loadData()
  }, [])

  return [loading, subscriptions, updateSubscriptions, savePreferences]

  async function loadData() {
    const lists = await subscriptionFormClient.getLists()
    setSubscriptions(createChannelSubscriptions(preferenceCenter, lists))
    setLoading(false)
  }
}
